export interface LabelProps {
  text: string
}

export function Label({ text }: LabelProps) {
  return (
    <div className="rounded-lg bg-bios-secondary px-3 py-2 text-center">
      <h1 className="text-nowrap text-xl font-bold text-white 2xl:text-3xl">
        {text}
      </h1>
    </div>
  )
}
